<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
            <h2 class="white--text">{{ $t('login.texts.resale') }}</h2>
            <v-card class="elevation-6">
                <v-toolbar flat>
                    <v-toolbar-title>{{
                        $t('login.texts.title')
                    }}</v-toolbar-title>
                </v-toolbar>

                <v-form @submit.prevent="login" ref="form" lazy-validation>
                    <v-card-text>
                        <v-text-field
                            :label="$t('login.labels.email')"
                            v-model="form.email"
                            prepend-icon="mdi-email"
                            type="email"
                            :error-messages="emailErrors"
                            @input="$v.form.email.$touch()"
                            @blur="$v.form.email.$touch()"
                            :autofocus="!form.email"
                        ></v-text-field>

                        <v-text-field
                            :label="$t('login.labels.password')"
                            v-model="form.password"
                            prepend-icon="mdi-lock"
                            type="password"
                            :error-messages="passwordErrors"
                            @input="$v.form.password.$touch()"
                            @blur="$v.form.password.$touch()"
                            :autofocus="!!form.email"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            class="light-blue accent-2"
                            dark
                            block
                            :loading="loading"
                            type="submit"
                            >{{ $t('login.buttons.submit') }}</v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card>
            <div class="mt-4 text-center">
                <v-btn small text dark :to="{ name: 'forget-password' }">{{
                    $t('login.buttons.forget-password')
                }}</v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],

    data() {
        return {
            form: {
                email: this.$store.getters['auth/lastUsername'],
                password: '',
            },
            loading: false,
        }
    },

    methods: {
        async login() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('login.bus.login-error'),
                )
                return
            }

            this.loading = true

            try {
                await this.$store
                    .dispatch('auth/login', this.form)
                    .catch(() => {
                        this.$bus.$emit(
                            'notify',
                            'error',
                            this.$t('login.bus.credentials-error'),
                        )
                        this.loading = false
                        return
                    })
            } finally {
                this.loading = false
            }

            this.$router.push({ name: 'dashboard' })
        },
    },

    validations: {
        form: {
            email: { required, email },
            password: { required },
        },
    },

    computed: {
        emailErrors() {
            const errors = []
            if (!this.$v.form.email.$dirty) return errors
            !this.$v.form.email.required &&
                errors.push(this.$t('login.messages.email-error-required'))
            !this.$v.form.email.email &&
                errors.push(this.$t('login.messages.email-error-email'))
            return errors
        },

        passwordErrors() {
            const errors = []
            if (!this.$v.form.password.$dirty) return errors
            !this.$v.form.password.required &&
                errors.push(this.$t('login.messages.password-error-required'))
            return errors
        },
    },
}
</script>
